const GA_BASE_URL = 'https://analyticsdata.googleapis.com/v1beta/properties';

type DateRange = { startDate: string; endDate: string; [key: string]: any };

const cleanRange = ({ startDate, endDate }: DateRange) => ({ startDate, endDate });

const runReport = async (token: string, propertyId: string, body: object) => {
  const res = await fetch(`${GA_BASE_URL}/${propertyId}:runReport`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw err?.error?.message || `GA API error ${res.status}`;
  }

  return res.json();
};

export const getGASummary = (token: string, propertyId: string, dateRange: DateRange) =>
  runReport(token, propertyId, {
    dateRanges: [cleanRange(dateRange)],
    metrics: [
      { name: 'activeUsers' },
      { name: 'sessions' },
      { name: 'screenPageViews' },
      { name: 'bounceRate' },
      { name: 'averageSessionDuration' },
    ],
  });

export const getTopPages = (token: string, propertyId: string, dateRange: DateRange) =>
  runReport(token, propertyId, {
    dateRanges: [cleanRange(dateRange)],
    dimensions: [{ name: 'pagePath' }, { name: 'pageTitle' }],
    metrics: [{ name: 'screenPageViews' }, { name: 'sessions' }, { name: 'activeUsers' }],
    orderBys: [{ metric: { metricName: 'screenPageViews' }, desc: true }],
    limit: 20,
  });

export const getUsersByCountry = (token: string, propertyId: string, dateRange: DateRange) =>
  runReport(token, propertyId, {
    dateRanges: [cleanRange(dateRange)],
    dimensions: [{ name: 'country' }],
    metrics: [{ name: 'activeUsers' }, { name: 'sessions' }, { name: 'newUsers' }],
    orderBys: [{ metric: { metricName: 'activeUsers' }, desc: true }],
    limit: 20,
  });

export const getTrafficByDevice = (token: string, propertyId: string, dateRange: DateRange) =>
  runReport(token, propertyId, {
    dateRanges: [cleanRange(dateRange)],
    dimensions: [{ name: 'deviceCategory' }],
    metrics: [{ name: 'sessions' }, { name: 'activeUsers' }, { name: 'screenPageViews' }],
    orderBys: [{ metric: { metricName: 'sessions' }, desc: true }],
  });
